import { StyleSheet, css } from 'aphrodite'
import type React from 'react'

interface OnboardingFooterProps {
  onNext: () => void
  onBack?: () => void
  nextText?: string
  backText?: string
  showBackButton?: boolean
  disabled?: boolean
}

const OnboardingFooter: React.FC<OnboardingFooterProps> = ({
  onNext,
  onBack,
  nextText = 'Next',
  backText = 'Back',
  showBackButton = true,
  disabled = false,
}) => (
  <div className={css(styles.footer)}>
    <div className={css(styles.buttonRow)}>
      {showBackButton && (
        <button className={css(styles.secondaryButton)} onClick={onBack}>
          {backText}
        </button>
      )}
      <button
        className={css(styles.primaryButton)}
        onClick={onNext}
        disabled={disabled}
      >
        {nextText}
      </button>
    </div>
  </div>
)

const styles = StyleSheet.create({
  footer: {
    marginTop: 'auto',
    paddingTop: 24,
    width: '100%',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  primaryButton: {
    background: '#2563EB',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '0 24px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
      background: '#1d4ed8',
    },
    ':disabled': {
      opacity: 0.7,
      cursor: 'not-allowed',
      ':hover': {
        background: '#2563EB',
      },
    },
  },
  secondaryButton: {
    background: '#fff',
    color: '#374151',
    border: '1px solid #d1d5db',
    borderRadius: 8,
    padding: '0 24px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
      background: '#f9fafb',
    },
  },
})

export default OnboardingFooter
